import * as _ from 'lodash';
import { IAttributeModel } from '../interfaces/attribute-model.interface';
import { IZoneCombinationModel } from '../interfaces/zone-combination-model.interface';
import { AttributeModel } from './attribute.model';
import IZoneCombination = ZoningAPI.IZoneCombination;

export class ZoneCombination implements IZoneCombinationModel {
    Id: number;
    RevisionId: number;
    CreatedOn?: Date;
    ModifiedOn?: Date;
    GridicsId?: string;
    IsNotCalibrated?: boolean;
    Description: string;
    CalibrationErrorMessage?: string;
    IsPlannedDevelopment?: boolean;
    CloneId?: number;
    BuildingTypologyMandatory?: boolean;
    DefaultBuildingTypology?: number;
    Name: string;
    CalibrationSetAttributes: IAttributeModel[];
    IsNotCalibratedReason?: string;

    _links: IAttributeModel[];

    constructor(data: IZoneCombination) {
        Object.assign(this, data);
        this.initAttributes();
    }

    get links(): IAttributeModel[] {
        if (_.isNil(this._links)) {
            this._links = this.CalibrationSetAttributes.filter(attribute => attribute.isLink);
        }
        return this._links;
    }

    private initAttributes() {
        this.CalibrationSetAttributes = !_.isEmpty(this.CalibrationSetAttributes)
            ? this.CalibrationSetAttributes.map(attribute => new AttributeModel(attribute))
            : [];
    }
}
